import { render, staticRenderFns } from "./DefaultPhoneInput.vue?vue&type=template&id=4a16322a"
import script from "./DefaultPhoneInput.vue?vue&type=script&lang=js"
export * from "./DefaultPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./DefaultPhoneInput.vue?vue&type=style&index=0&id=4a16322a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports